import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Horse_show_entry } from '../models/horse_show_entry';
import { Statement } from '../models/accounting/statement';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class RiderNominationService {

  constructor(private http: HttpClient) { }

    create(horse_show_entry: Horse_show_entry): Promise<Horse_show_entry> {

    let post_data = {
        data: {
          type: 'rider_nomination',
          attributes: { horse_show_entry: horse_show_entry }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'rider_nominations',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='horse_show_entry') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : JSON.stringify(error));
                  }
                });
            });

  }


}
